<template>
  <div class="room_cabin_detail border-grey c_room_cabin">
    <div id=""
      class="room_cabinFree c_room_free js-connect-room js-stateroom"
      style="display: block"
    >
      <div class="room_cabin_m">
        <div class="cabin_detail_img js-connect-room">
          <img
            class=""
            v-lazy="stateroomFirst.stateroomDesImgUrl"
            :alt="stateroomName(stateroomFirst)"
            @click="onStateroomClicked($event, stateroomFirst, 1)"
          />
        </div>
        <div class="cabin_detail_desc">
          <div class="detail_desc_info">
            <div class="detail_desc_name">
              <div class="detail_desc_nameTxt">
                {{ stateroomName(stateroomFirst) }}
              </div>
              <img class="deluxe-tag"
                   v-if="stateroomType === 'DELUXE' && stateroomFirst.suiteType >= 0"
                   @click="onShowStateroomSuitePopup(stateroomFirst.suiteMobileImageUrl)"
                   :src="GlobalData.suiteTagImgValue[stateroomFirst.suiteType]"/>
              <div
                v-else-if="getStateroomTage(stateroomFirst).length > 0"
                class="cabin_detail_tag"
                @click="
                  onShowStateroomSuitePopup(stateroomFirst.suiteMobileImageUrl)
                "
              >
                {{ getStateroomTage(stateroomFirst) }}
              </div>
            </div>
            <div class="detail_desc_area">
              <span>{{ stateroomFirst.stateroomArea }}</span
              ><span>{{ stateroomBalconyArea(stateroomFirst) }}</span
              ><span>{{ stateroomFirst.stateroomFloorInfo }}</span
              ><span>{{ stateroomFirst.commentTag }}</span>
            </div>
          </div>
          <img v-if="stateroomFirst.groupType == 'QIAOHU' || stateroomFirst.groupType == 'QIAOHU_AL'"
               @click.prevent="showQiaohuPopup(stateroomFirst)" class="QIAOHU_CSS"
               src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg">
          <img v-else-if="stateroomFirst.groupType == 'STARRYSKY'"
               @click.prevent="showStarrySkyPopup(stateroomFirst)" class="STARRYSKY_CSS"
               src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png">
          <img v-else-if="stateroomFirst.groupType == 'PCPGIFT'"
               @click.prevent="showCustomThemePopup(stateroomFirst?.personalizedStateroomInfo)" class="PCP_GIFT_THEME_CSS"
               :src="stateroomFirst?.personalizedStateroomInfo.roomIconImage">
          <img v-else-if="stateroomFirst.groupType == 'CUSTOM'"
               @click.prevent="showCustomThemePopup(stateroomFirst?.personalizedStateroomInfo)" class="CUSTOM_THEME_CSS"
               :src="stateroomFirst?.personalizedStateroomInfo.roomIconImage">
          <template v-if="stateroomType === 'DELUXE'">
            <DeviceFeatureTags :view-num="2" is-detail :tags="stateroomFirst.deviceFeatureTags" @submit="onStateroomClicked($event, stateroomFirst, 1)"></DeviceFeatureTags>
          </template>
          <template v-else>
            <DeviceFeatureTags is-detail :tags="stateroomFirst.deviceFeatureTags" @submit="onStateroomClicked($event, stateroomFirst, 1)"></DeviceFeatureTags>
          </template>
          <div class="detail_desc_price">
            <div class="desc_price_txt">
              <span class="detail_desc_price_title"
                >{{ priceType(1) }}(含税):</span
              >
              <span class="desc_price_unit">￥</span>
              <span class="stateroomTypePrice">{{
                netAmountStr(stateroomFirst, 1)
              }}</span>
              /人起
            </div>
<!--            <div class="desc_price_txt2">-->
<!--              零售指导价(含税)¥{{ originalAmountStr(stateroomFirst) }}/人起-->
<!--            </div>-->
            <div class="desc_bottom">
              <div v-if="firstAmountPerNight" class="desc_per_night">平均每晚￥{{firstAmountPerNight}}/人起</div>
              <div class="room_orderChange_box">
                <div
                  class="room_orderChange js-orderChangeBtn js-connect-room"
                  :class="{
                    rpOnly: !hasNrp(stateroomFirst) || !hasRp(stateroomFirst),
                  }"
                  @click="onSelectNrpChange($event, stateroomFirst, 1)"
                >
                  <div
                    :class="{ active: firstSelectNrp }"
                    v-show="hasNrp(stateroomFirst)"
                  >
                    {{ getNrpTitle(true) }}
                  </div>
                  <div
                    :class="{ active: !firstSelectNrp }"
                    v-show="hasRp(stateroomFirst)"
                  >
                    {{ getNrpTitle(false) }}
                  </div>
                </div>
                <img class="room_orderChange_icons"
                     @click="handleRoomUnsubscribedOpen($event, firstSelectNrp)"
                     :src="`${imgUrl}/icons/iconQuestionMark.svg`"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="room_cabinFree c_cabinFree js-connect-room js-stateroom"
      style="display: block; margin-top: 12px"
    >
      <div class="room_cabin_m">
        <div class="cabin_detail_img js-connect-room">
          <img
            class=""
            v-lazy="stateroomSecond.stateroomDesImgUrl"
            :alt="stateroomName(stateroomSecond)"
            @click="onStateroomClicked($event, stateroomSecond, 2)"
          />
        </div>
        <div class="cabin_detail_desc">
          <div class="detail_desc_info">
            <div class="detail_desc_name">
              <div class="detail_desc_nameTxt">
                {{ stateroomName(stateroomSecond) }}
              </div>
              <img class="deluxe-tag"
                   v-if="stateroomType === 'DELUXE' && stateroomSecond.suiteType >= 0"
                   @click="onShowStateroomSuitePopup(stateroomSecond.suiteMobileImageUrl)"
                   :src="GlobalData.suiteTagImgValue[stateroomSecond.suiteType]"/>
              <div
                v-else-if="getStateroomTage(stateroomSecond).length > 0"
                class="cabin_detail_tag"
                @click="
                  onShowStateroomSuitePopup(stateroomSecond.suiteMobileImageUrl)
                "
              >
                {{ getStateroomTage(stateroomSecond) }}
              </div>
            </div>
            <div class="detail_desc_area">
              <span>{{ stateroomSecond.stateroomArea }}</span
              ><span>{{ stateroomBalconyArea(stateroomSecond) }}</span
              ><span>{{ stateroomSecond.stateroomFloorInfo }}</span
              ><span>{{ stateroomSecond.commentTag }}</span>
            </div>
          </div>
          <img v-if="stateroomSecond.groupType == 'QIAOHU' || stateroomSecond.groupType == 'QIAOHU_AL'"
               @click.prevent="showQiaohuPopup(stateroomSecond)" class="QIAOHU_CSS"
               src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg">
          <img v-else-if="stateroomSecond.groupType == 'STARRYSKY'"
               @click.prevent="showStarrySkyPopup(stateroomSecond)" class="STARRYSKY_CSS"
               src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png">
          <img v-else-if="stateroomSecond.groupType == 'PCPGIFT'"
               @click.prevent="showCustomThemePopup(stateroomSecond?.personalizedStateroomInfo)" class="PCP_GIFT_THEME_CSS"
               :src="stateroomSecond?.personalizedStateroomInfo.roomIconImage">
          <img v-else-if="stateroomSecond.groupType == 'CUSTOM'"
               @click.prevent="showCustomThemePopup(stateroomSecond?.personalizedStateroomInfo)" class="CUSTOM_THEME_CSS"
               :src="stateroomSecond?.personalizedStateroomInfo.roomIconImage">
          <template v-if="stateroomType === 'DELUXE'">
            <DeviceFeatureTags :view-num="2" is-detail :tags="stateroomSecond.deviceFeatureTags" @submit="onStateroomClicked($event, stateroomSecond, 1)"></DeviceFeatureTags>
          </template>
          <template v-else>
            <DeviceFeatureTags is-detail :tags="stateroomSecond.deviceFeatureTags" @submit="onStateroomClicked($event, stateroomSecond, 1)"></DeviceFeatureTags>
          </template>
          <div class="detail_desc_price">
            <div class="desc_price_txt">
              <span class="detail_desc_price_title"
                >{{ priceType(2) }}(含税):</span
              >
              <span class="desc_price_unit">￥</span>
              <span class="stateroomTypePrice">{{
                netAmountStr(stateroomSecond, 2)
              }}</span>
              /人起
            </div>
            <div class="desc_bottom">
              <div v-if="secondAmountPerNight" class="desc_per_night">平均每晚￥{{secondAmountPerNight}}/人起</div>
  <!--            <div class="desc_price_txt2">-->
  <!--              零售指导价(含税)¥{{ originalAmountStr(stateroomSecond) }}/人起-->
  <!--            </div>-->
              <div class="room_orderChange_box">
                <div
                  class="room_orderChange js-orderChangeBtn js-connect-room"
                  :class="{
                    rpOnly: !hasNrp(stateroomSecond) || !hasRp(stateroomSecond),
                  }"
                  @click="onSelectNrpChange($event, stateroomSecond, 2)"
                >
                  <div
                    :class="{ active: secondSelectNrp }"
                    v-show="hasNrp(stateroomSecond)"
                  >
                    {{ getNrpTitle(true) }}
                  </div>
                  <div
                    :class="{ active: !secondSelectNrp }"
                    v-show="hasRp(stateroomSecond)"
                  >
                    {{ getNrpTitle(false) }}
                  </div>
                </div>
                <img class="room_orderChange_icons"
                     @click="handleRoomUnsubscribedOpen($event, secondSelectNrp)"
                     :src="`${imgUrl}/icons/iconQuestionMark.svg`"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="c_room_text">
      已经帮您算好了哦，两间{{ guestNumber }}人总价￥<span
        class="js-connect-room-total-price"
        >{{ connectAmountStr() }}</span
      >元
    </div>
    <div class="c_detail_skip detail_skip_room">
      <div
        class="reduce_room js-connect-room"
        @click="shoppingCartDelete($event)"
      >
        <span class="cart-action-icon cart-action-icon-reduce" aria-hidden="true"></span>
      </div>
      <span class="skip_room_number">
        <span class="skip_roomSelCount">{{ shoppingCartNum }}</span>
      </span>
      <div
        class="plus_room js-connect-room"
        @click="connectShoppingCartAdd($event)"
      >
        <span class="cart-action-icon cart-action-icon-plus" aria-hidden="true"></span>
      </div>
    </div>
    <div class="c_room_connect">关门隔断&nbsp;&nbsp;开门互通</div>
    <img
      @click="onShowConnectRoomPopup()"
      class="c_img_top"
      src="https://resource.rcclchina.com.cn/connectRoom/mb_connect_top.png?v=1"
      alt=""
    />

    <!-- 收费/常规退订弹窗 -->
    <NrpPopup
        :isShow="isShowNrpPopup"
        :nrpDescription="nrpDescription"
        :onCloseNrpPopup="handleRoomUnsubscribedClose"
    />
  </div>
</template>

<script>
import nrpConfig from "@/utilities/nrpConfig";
import {dateStrToTimeTamp, gioTracking} from "@/utilities/tools";
import NrpPopup from "@/components/Booking/NrpPopup.vue";
const DeviceFeatureTags = ()=> import("@/components/Cruise/DeviceFeatureTags");
import api from "@/api";
export default {
  name: "ConnectStateroomItem",
  components: {
    NrpPopup,
    DeviceFeatureTags
  },
  props: {
    shipCode: {
      type: String,
    },
    sailDate: {
      type: String,
    },
    packageCode: {
      type: String,
    },
    connectStateroom: {
      type: Object,
      default() {
        return {};
      },
    },
    stateroomType: {
      type: String,
    },
    shoppingCarts: {
      type: Array,
      default() {
        return [];
      },
    },
    onConnectShoppingCartAdd: {
      type: Function,
    },
    onShoppingCartDelete: {
      type: Function,
    },
    showStateroomDetail: {
      type: Function,
    },
    showStateroomSuitePopup: {
      type: Function,
    },
    showConnectRoomPopup: {
      type: Function,
    },
    isFortyEightHoursNrpCruise: {
      type: Boolean,
    },
    nrpDefaultSelectedType: {
      type: Number
    },
    allowUseTikTokCode: {
      type: Boolean,
      default: false
    },
    showQiaohuPopup: {
      type: Function
    },
    showStarrySkyPopup: {
      type: Function
    },
    showCustomThemePopup: {
      type: Function
    },
        showRow: {
            type: Boolean,
            default () {
                return false
            }
        },
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      firstSelectNrp: true,
      secondSelectNrp: true,
      isShowNrpPopup: false,
      nrpDescription: ""
    };
  },
  beforeMount() {
    this.initSelectNrp();
  },
  methods: {
    initSelectNrp() {
      this.initSelectNrpByStateroom(this.stateroomFirst, 1);
      this.initSelectNrpByStateroom(this.stateroomSecond, 2);
    },
    initSelectNrpByStateroom(stateroom, stateroomIndex) {
      if (!stateroom.price || stateroom.price.length == 0) {
        return;
      }
      let nrp = 0;
      const nrpPrice = stateroom.price.filter((r) => r.isnrp);
      nrp = nrpPrice.length > 0 ? nrpPrice[0].netAmount : 0;
      let rp = 0;
      const rpPrice = stateroom.price.filter((r) => !r.isnrp);
      rp = rpPrice.length > 0 ? rpPrice[0].netAmount : 0;

      if(this.allowUseTikTokCode) {
        rp = 0;
      }
      // 临时修改，不管NRP和RP的价格高低，都默认选中RP价格
      // if (nrp > 0 && nrp <= rp) {
      //     if (stateroomIndex == 1) {
      //         this.firstSelectNrp = true
      //     } else {
      //         this.secondSelectNrp = true
      //     }
      // } else {
      //     if (stateroomIndex == 1) {
      //         this.firstSelectNrp = false
      //     } else {
      //         this.secondSelectNrp = false
      //     }
      // }

      //nrpDefaultSelectedType 0:默认-按nrp 1:常规rp | 2:收费nrp
      if (rp > 0 && nrp > 0) {
        if (stateroomIndex == 1) {
          this.firstSelectNrp = this.nrpDefaultSelectedType === 0 || this.nrpDefaultSelectedType === 2;
        } else {
          this.secondSelectNrp = this.nrpDefaultSelectedType === 0 || this.nrpDefaultSelectedType === 2;
        }
      } else if (rp > 0) {
        if (stateroomIndex == 1) {
          this.firstSelectNrp = false;
        } else {
          this.secondSelectNrp = false;
        }
      } else if (nrp > 0) {
        if (stateroomIndex == 1) {
          this.firstSelectNrp = true;
        } else {
          this.secondSelectNrp = true;
        }
      }

      // if (rp > 0) {
      //   if (stateroomIndex == 1) {
      //     //nrpDefaultSelectedType 0:默认nrp | 1:常规rp | 2:收费nrp
      //     this.firstSelectNrp = this.nrpDefaultSelectedType === 2 && nrp > 0 || this.nrpDefaultSelectedType === 0;
      //   } else {
      //     this.secondSelectNrp = this.nrpDefaultSelectedType === 2 && nrp > 0 || this.nrpDefaultSelectedType === 0;
      //   }
      // } else if (nrp > 0) {
      //   if (stateroomIndex == 1) {
      //     this.firstSelectNrp = this.nrpDefaultSelectedType === 2 || this.nrpDefaultSelectedType === 0;
      //   } else {
      //     this.secondSelectNrp = this.nrpDefaultSelectedType === 2 || this.nrpDefaultSelectedType === 0;
      //   }
      // }
    },
    //根据默认选中收费退订
    getCurrentIsNrpDefault() {
      let currDate = dateStrToTimeTamp(this.sailDate);
      let beginDate = dateStrToTimeTamp("2024-07-03");
      let endDate = dateStrToTimeTamp("2024-08-24");
      return this.shipCode === 'SC' && (currDate >= beginDate && currDate <= endDate);
    },
    stateroomName(stateroom) {
      return stateroom.stateroomCNName + "_" + this.categoryCode(stateroom);
    },
    stateroomBalconyArea(stateroom) {
      if (
        !stateroom.stateroomBalconyArea ||
        stateroom.stateroomBalconyArea.length == 0 ||
        stateroom.stateroomBalconyArea == "无"
      ) {
        return "无阳台";
      }
      return stateroom.stateroomBalconyArea;
    },
    getStateroomTage(stateroom) {
      if (stateroom.tag && stateroom.tag.length > 0) {
        return stateroom.tag;
      } else if (stateroom.suiteType == 1) {
        return "银卡礼遇";
      } else if (stateroom.suiteType == 2) {
        return "金卡礼遇";
      }
      return "";
    },
    priceType(stateroomIndex) {
      let isnrp =
        stateroomIndex == 1 ? this.firstSelectNrp : this.secondSelectNrp;
      if (isnrp) {
        return nrpConfig.nrp.priceType;
      }
      return nrpConfig.rp.priceType;
    },
    nrpTitle(stateroomIndex) {
      let isnrp =
        stateroomIndex == 1 ? this.firstSelectNrp : this.secondSelectNrp;
      if (isnrp) {
        return "收费退订";
      }
      return "常规退订";
    },
    nrpText(stateroomIndex) {
      let isnrp =
        stateroomIndex == 1 ? this.firstSelectNrp : this.secondSelectNrp;
      if (isnrp) {
        return nrpConfig.nrp.description;
      } else {
        return nrpConfig.rp.description;
      }
    },
    netAmountByCabin(stateroom, stateroomIndex) {
      let isnrp =
        stateroomIndex == 1 ? this.firstSelectNrp : this.secondSelectNrp;
      let price = 0;
      const priceObj = stateroom.price.filter((r) => r.isnrp == isnrp);
      price = priceObj.length > 0 ? priceObj[0].perPeopleAmount : 0;
      return price;
    },
    netAmountPerGuest(stateroom, stateroomIndex) {
      const price = this.netAmountByCabin(stateroom, stateroomIndex);
      return price;
    },
    netAmountStr(stateroom, stateroomIndex) {
      let price = this.netAmountPerGuest(stateroom, stateroomIndex);
      if (price == 0) {
        return "";
      }
      return price.toFixed(0);
    },
    originalAmountStr(stateroom) {
      let price = stateroom.originalAmount / stateroom.guestNumber;
      if (price == 0) {
        return "";
      }
      return price.toFixed(0);
    },
    connectAmountStr() {
      const price = (this.netAmountByCabin(this.stateroomFirst, 1) * this.stateroomFirst.guestNumber) +
          (this.netAmountByCabin(this.stateroomSecond, 2) * this.stateroomSecond.guestNumber);
      return price.toFixed(0);
    },

    hasNrp(stateroom) {
      if(this.allowUseTikTokCode) {
        return true;
      }
      return stateroom.price && stateroom.price.some((r) => r.isnrp);
    },
    hasRp(stateroom) {
      if(this.allowUseTikTokCode) {
        return false;
      }
      return stateroom.price && stateroom.price.some((r) => !r.isnrp);
    },
    isQiaohu(stateroom) {
      return stateroom.groupType && stateroom.groupType == "QIAOHU";
    },
    isStarrySky(stateroom) {
      return stateroom.groupType && stateroom.groupType == "STARRYSKY";
    },
    categoryCode(stateroom) {
      let code = stateroom.stateroomCategoryCode + "";
      if (code.indexOf("_") >= 0) {
        code = code.split("_")[0];
      }
      return code;
    },
    getNrpTitle(isNrp) {
      if (this.isFortyEightHoursNrpCruise) {
        return nrpConfig.fortyEightHoursNrp.title;
      } else if (isNrp) {
        return nrpConfig.nrp.title;
      }
      return nrpConfig.rp.title;
    },
    onSelectNrpChange(e, stateroom, stateroomIndex) {
      e.stopPropagation();
      if (stateroomIndex == 1) {
        this.firstSelectNrp = this.changeSelectNrp(
          stateroom,
          stateroomIndex,
          this.firstSelectNrp
        );
      } else {
        this.secondSelectNrp = this.changeSelectNrp(
          stateroom,
          stateroomIndex,
          this.secondSelectNrp
        );
      }
    },
    changeSelectNrp(stateroom, stateroomIndex, selectNrp) {
      if (selectNrp == false && this.hasNrp(stateroom, stateroomIndex)) {
        selectNrp = true;
      } else if (selectNrp == true && this.hasRp(stateroom, stateroomIndex)) {
        selectNrp = false;
      }
      return selectNrp;
    },
    // 连通房加购物车，需要把两间都加进去
    connectShoppingCartAdd(e) {
      e.stopPropagation();
      const first = this.shoppingCartAdd(
        this.stateroomFirst,
        this.firstSelectNrp
      );
      if (!first) return;
      const second = this.shoppingCartAdd(
        this.stateroomSecond,
        this.secondSelectNrp
      );
      if (!second) return;
      this.onConnectShoppingCartAdd([first, second]);
    },
    shoppingCartAdd(stateroom, selectNrp) {
      const price = stateroom.price.filter((r) => r.isnrp == selectNrp);
      if (!price || price.length == 0) {
        return;
      }
      const model = {
        shipCode: this.shipCode,
        sailDate: this.sailDate,
        productPackageId: -1,
        packageId: this.packageCode,
        stateroomCategoryCode: stateroom.stateroomCategoryCode,
        stateroomClass: this.stateroomType,
        fareCode: price[0].fareCode,
        guestNumber: stateroom.guestNumber,
        originAmount: price[0].originalAmount / stateroom.guestNumber,
        netAmount: price[0].netAmount / stateroom.guestNumber,
        amountPerNight: price[0].amountPerNight,
        isNrp: selectNrp,
        groupAgencyId: "",
        groupAgencyName: "",
        requestsequence: "",
        groupType: "",
        groupId: "",
        connectId: this.connectStateroom.connectId,
      };
      return model;
    },
    // 删除购物车，由于接口支持删除其中一间房间后，把对应另外一间连通房也删掉，所以前端只需要删一间房间就可以了
    shoppingCartDelete(e) {
      e.stopPropagation();
      if (this.shoppingCartNum > 0) {
        const price = this.stateroomFirst.price;
        const model = {
          shipCode: this.shipCode,
          sailDate: this.sailDate,
          productPackageId: -1,
          packageId: this.packageCode,
          stateroomCategoryCode: this.stateroomFirst.stateroomCategoryCode,
          stateroomClass: this.stateroomType,
          fareCode: price[0].fareCode,
          guestNumber: this.stateroomFirst.guestNumber,
          originAmount:
            price[0].originalAmount / this.stateroomFirst.guestNumber,
          netAmount: price[0].netAmount / this.stateroomFirst.guestNumber,
          isNrp: this.firstSelectNrp,
          groupAgencyId: "",
          groupAgencyName: "",
          requestsequence: "",
          groupType: "",
          groupId: "",
          connectId: this.connectStateroom.connectId,
        };
        this.onShoppingCartDelete(model);
      }
    },
    async onStateroomClicked(e, stateroom, stateroomIndex) {
      e.stopPropagation();
      this.$loading.show()
      const { success,data } = await api.cruise.getStateroomDetailApi({
        stateroomPartRecordId: stateroom.stateroomPartRecordId
      });
      this.$loading.hide()
      if(success) {
        let stateroomApi = {...data};
        const stateroomData = {
          stateroomType: this.stateroomType,
          stateroomImages: stateroom.stateroomImages,
          stateroomName: stateroom.stateroomCNName,
          stateroomCategory: stateroom.stateroomCategoryCode,
          stateroomPriceType: this.priceType(stateroomIndex),
          stateroomPrice: this.netAmountPerGuest(stateroom, stateroomIndex),
          stateroomCapacity: stateroom.stateroomCapacity,
          stateroomArea: stateroom.stateroomArea,
          stateroomBalcony: stateroom.stateroomBalconyArea,
          stateroomFloor: stateroom.stateroomFloorInfo,
          isQiaohu: this.isQiaohu(stateroom),
          isStarrySky: this.isStarrySky(stateroom),
          suiteType: stateroom.suiteType,
          stateroomDescription: stateroomApi?.stateroomDescription,
          stateroomNrpTitle: this.nrpTitle(stateroomIndex),
          stateroomNrpText: this.nrpText(stateroomIndex),

          stateroomImageDataList: [...(stateroomApi.stateroomImageDataList ?? [])],
          roomSummaryList: stateroom.roomSummaryList,
          suiteRightsCount: stateroom.suiteRightsCount,
          vrUrl: stateroom.vrUrl,
          suiteImageUrl: stateroom.suiteImageUrl,
          currentGuestNumber: stateroom.currentGuestNumber,
          guestNumber: stateroom.guestNumber,
          
          deviceFeatureTags: stateroom.deviceFeatureTags,
          deviceGroupTags: [...(stateroomApi.deviceGroupTags ?? [])]
        };
        this.showStateroomDetail(stateroomData);
        gioTracking('track', 'evt_RoomDetailClick', {
          'GuestNumber': stateroom.guestNumber,
          'RoomType': 'Connecting',
          'RoomClass': stateroom.stateroomType,
          'RoomCategory': stateroom.stateroomCategoryCode,
          'shipCode': this.shipCode,
          'sailDate': this.sailDate
        });
      }
    },
    onShowStateroomSuitePopup(suiteImage) {
      if (suiteImage && suiteImage.length > 0 && this.shipCode!=='OV') {
        this.showStateroomSuitePopup(suiteImage);
      }
    },
    onShowConnectRoomPopup() {
      this.showConnectRoomPopup();
    },
    handleRoomUnsubscribedOpen(e, isNrp) {
      e.stopPropagation();
      this.isShowNrpPopup = true;
      // this.nrpDescription = isNrp ? nrpConfig.nrp.description : nrpConfig.rp.description;
      if(isNrp){
        // 收费退订
                if(this.showRow){
                    this.nrpDescription = this.$store.state.cruiseRow.nrpData.cancelPolicyNrpRow
                }else{
                    this.nrpDescription =  this.$store.state.cruiseRow.nrpData.cancelPolicyNrp
                }
      }else{
        // 常规退订
                if(this.showRow){
                    this.nrpDescription =  this.$store.state.cruiseRow.nrpData.cancelPolicyRow
                }else{
                    this.nrpDescription = this.$store.state.cruiseRow.nrpData.cancelPolicy
                }
      }
    },
    handleRoomUnsubscribedClose() {
      this.isShowNrpPopup = false;
      this.nrpDescription = "";
    }
  },
  computed: {
    firstAmountPerNight() {
      if(this.stateroomFirst.price.length === 1) {
        return this.stateroomFirst.price[0]?.perNightAmount ? this.stateroomFirst.price[0]?.perNightAmount.toFixed(0) : null;
      }
      if(this.firstSelectNrp) {
        return this.stateroomFirst.price[0]?.perNightAmount ? this.stateroomFirst.price[0]?.perNightAmount.toFixed(0) : null;
      } else {
        return this.stateroomFirst.price[1]?.perNightAmount ? this.stateroomFirst.price[1]?.perNightAmount.toFixed(0) : null;
      }
    },
    secondAmountPerNight() {
      if(this.stateroomSecond.price.length === 1) {
        return this.stateroomSecond.price[0]?.perNightAmount ? this.stateroomSecond.price[0]?.perNightAmount.toFixed(0) : null;
      }
      if(this.secondSelectNrp) {
        return this.stateroomSecond.price[0]?.perNightAmount ? this.stateroomSecond.price[0]?.perNightAmount.toFixed(0) : null;
      } else {
        return this.stateroomSecond.price[1]?.perNightAmount ? this.stateroomSecond.price[1]?.perNightAmount.toFixed(0) : null;
      }
    },
    stateroomFirst() {
      return this.connectStateroom.connectStateroomFirsts;
    },
    stateroomSecond() {
      return this.connectStateroom.connectStateroomSeconds;
    },
    shoppingCartNum() {
      const first = this.shoppingCarts.filter(
        (r) =>
          r.connectId &&
          r.connectId.length > 0 &&
          r.berthedCategoryCode == this.stateroomFirst.stateroomCategoryCode &&
          r.isnrp == this.firstSelectNrp &&
          r.bookingShoppingCart
      );
      if (first.length == 0) {
        return 0;
      }
      const firstId = first[0].bookingShoppingCart.id;

      const hasSecond = this.shoppingCarts.some(
        (r) =>
          r.connectId &&
          r.connectId.length > 0 &&
          r.berthedCategoryCode == this.stateroomSecond.stateroomCategoryCode &&
          r.isnrp == this.secondSelectNrp &&
          r.bookingShoppingCart &&
          r.bookingShoppingCart.id != firstId
      );

      if (hasSecond) {
        return 2;
      }
      return 0;
    },
    guestNumber() {
      return this.stateroomFirst.guestNumber + this.stateroomSecond.guestNumber;
    },
  },
};
</script>

<style lang="less" scoped>
.c_room_cabin {
  position: relative;
  max-width: 375px;
  padding: 35px 0px 4px 0px;
  max-height: 100%;
  padding-bottom: 4px;
  border: 2px solid #febc10 !important;
  margin-bottom: 10px;
  border-top: 0;
  border-radius: 8px;
  .room_cabinFree {
    position: relative;
    margin-left: 8px;
    z-index: 2;
    .room_cabin_m {
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      .cabin_detail_img {
        width: 100px;
        height: 100px;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .cabin_detail_desc {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -moz-box-orient: vertical;
        -moz-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -moz-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        padding: 0 0 0 10px;
        font-size: 12px;
        .detail_desc_name {
          font-size: 14px;
          line-height: 1;
          color: #333;
          font-weight: bold;
          .detail_desc_nameTxt {
            margin-bottom: 8px;
            margin-right: 5px;
            display: inline-block;
            max-width: 74%;
          }
        }
        .detail_desc_area {
          font-size: 12px;
          line-height: 1;
          color: #666;
          span {
            display: inline-block;
          }
          span + span {
            margin-left: 10px;
            padding-left: 10px;
            border-left: 1px solid #979797;
          }
        }
        .detail_desc_price {
          margin-top: 8px;
          .desc_price_txt,
          .desc_price_txt span.detail_desc_price_title {
            font-size: 10px;
            line-height: 14px;
            color: #666;
            font-weight: normal;
            & .stateroomTypePrice {
              font-size: 18px;
            }
          }
          .desc_price_txt {
            span {
              font-size: 12px;
              line-height: 1;
              color: #ff5055;
              font-weight: bold;
            }
          }
          .desc_price_txt2 {
            margin-top: 4px;
            font-size: 10px;
            line-height: 1;
            color: #aaa;
            text-decoration: line-through;
          }

          .desc_bottom {
            overflow: hidden;
            margin-top: 5px;
            margin-right: -4px;
            & .desc_per_night {
              float: left;
              line-height: 18px;
              letter-spacing: -1px;
              color: #a6aeb1;
            }
            & .room_orderChange_box {
              display: flex;
              align-items: center;
              gap: 0 4px;
              & .room_orderChange {
                float: right;
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                width: 112px;
                height: 18px;
                background: #f3f6f7;
                border: 1px solid #d3dadd;
                border-radius: 10px;
                -webkit-border-radius: 10px;
                -moz-border-radius: 10px;
                > div {
                  -webkit-box-flex: 1;
                  -webkit-flex: 1;
                  -moz-box-flex: 1;
                  -ms-flex: 1;
                  flex: 1;
                  font-size: 10px;
                  line-height: 16px;
                  color: #a6aeb1;
                  text-align: center;
                }
                .active {
                  background: #f0b012;
                  border: none;
                  color: #fff;
                  background: #4a90e2;
                  border-radius: 10px;
                  -webkit-border-radius: 10px;
                }
              }
              .room_orderChange.rpOnly {
                width: 56px;
              }
              & .room_orderChange_icons {
                display: inline-flex;
                width: 16px;
                height: 16px;
              }
            }
          }
        }
      }
    }
  }
  .c_room_free {
    margin-bottom: 12px;
    margin-right: 10px;
  }
  .c_cabinFree {
    padding-bottom: 9px;
    margin-right: 10px;
    border-bottom: 1px solid #e1e1e1;
  }

  .c_room_text {
    width: 100%;
    line-height: 32px;
    text-align: left;
    color: #333;
    font-size: 12px;
    margin-left: 6px;
    font-weight: bold;
  }

  .detail_skip_room {
    position: absolute;
    width: 18%;
    bottom: 6px;
    right: 6px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    .skip_room_number {
      width: 29px;
      font-size: 15px;
      line-height: 1;
      color: #000;
      text-align: center;
      margin-top: -1px;
    }
    .cart-action-icon {
      display: block;
      position: relative;
      width: 19px;
      height: 19px;
      box-sizing: border-box;
      border-radius: 50%;
    }
    .cart-action-icon:before,
    .cart-action-icon:after {
      content: '';
      position: absolute;
      left: 3px;
      top: 8px;
      width: 11px;
      height: 1px;
      background-color: #fff;
    }
    .cart-action-icon-reduce {
      border: 1px solid #4a90e2;
    }
    .cart-action-icon-plus {
      background-color: #febc10;
      border: 1px solid #febc10;
    }
    .cart-action-icon-reduce:before,
    .cart-action-icon-reduce:after {
      background-color: #4a90e2;
    }
    .cart-action-icon-reduce:after {
      display: none;
    }
    .cart-action-icon-plus:after {
      transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
    }
  }

  .c_room_connect {
    width: 100px;
    height: 17px;
    position: absolute;
    top: 135px;
    left: 8px;
    text-align: center;
    background-color: #febc10;
    font-size: 10px;
    color: #051555;
    font-weight: bold;
    line-height: 17px;
    padding: 0 3px;
    letter-spacing: -1px;
  }

  .c_room_connect_large {
    height: 33px;
    line-height: 33px;
  }

  .c_img_top {
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;
  }
}
.cabin_detail_tag {
  background-color: #fffae7;
  border-radius: 12px;
  border: solid 1px #ffa70d;
  font-size: 11px;
  color: #ffa70d;
  text-align: center;
  width: 72px;
  line-height: 16px;
  font-weight: normal;
  display: inline-block;
  margin-bottom: 5px;
  vertical-align: middle;
}
.deluxe-tag {
  width: 50px;
  display: inline-block;
  margin-bottom: 3px;
  vertical-align: top;
}

.detail_desc_tags {
  margin-top: 6px;
  overflow: hidden;
  & .tags_list {
    float: left;
    height: 16px;
    & > li {
      display: inline-block;
      overflow: hidden;
      margin-right: 8px;
      height: 16px;
      & > img {
        float: left;
        height: 16px;
      }
      & > div {
        float: left;
        line-height: 15px;
        letter-spacing: -1px;
      }
    }
  }
  & .tags_arrow {
    float: left;
    margin-top: 3px;
  }
}

.QIAOHU_CSS {
  background-size: 100% 100%;
  width: 113px;
  display: block;
  margin-top: 5px;
}

.STARRYSKY_CSS {
  background-size: 100% 100%;
  width: 113px;
  display: block;
  margin-top: 5px;
}
.PCP_GIFT_THEME_CSS {
  background-size: 100% 100%;
  width: 90px;
  display: block;
  margin-top: 5px;
}
.CUSTOM_THEME_CSS {
  background-size: 100% 100%;
  width: 90px;
  display: block;
  margin-top: 5px;
}
</style>
